import { cloneDeep } from 'lodash'
import { ISensitiveFieldInfo, MASKED_DATA_VALUE } from '../types'

export type MaybeMaskedData<T extends object> = { [K in keyof T]: T[K] | string }

/**
 * THIS IS A PROTOTYPE IMPLEMENTATION THAT MOST LIKELY WILL NOT WORK IN MANY CASES.
 * DO NOT TRUST THIS CODE NOT TO BREAK THINGS.
 */
export class SensitiveDataMasker {
  public static maskData<T extends object>(data: T, sensitiveFields: Array<ISensitiveFieldInfo<T>>): T {
    const maskedData: T = { ...data } // Shallow copy

    for (const fieldInfo of sensitiveFields) {
      if (Object.prototype.hasOwnProperty.call(maskedData, fieldInfo.field)) {
        // This in particular is a giant hack that likely won't cover most cases.
        // Could use a masking library like https://github.com/Sumukha1496/maskdata

        ;(maskedData as unknown as T)[fieldInfo.field] = MASKED_DATA_VALUE as T[keyof T]
      }
    }
    return maskedData
  }

  /**
   * This is a helper function that returns a new object with the masked data removed.
   * This is useful for when you want to return a subset of the data without the masked data.
   */
  public static copyWithoutMaskedData<T extends object>({
    data,
    sensitiveFields,
  }: {
    data: MaybeMaskedData<T>
    sensitiveFields: Array<ISensitiveFieldInfo<T>>
  }): Partial<T> {
    const withoutMaskedData: Partial<T> = cloneDeep(data) as Partial<T>

    for (const fieldInfo of sensitiveFields) {
      const hasProperty = Object.prototype.hasOwnProperty.call(withoutMaskedData, fieldInfo.field)
      const isMasked =
        hasProperty &&
        typeof withoutMaskedData[fieldInfo.field] === 'string' &&
        withoutMaskedData[fieldInfo.field] === MASKED_DATA_VALUE

      if (hasProperty && isMasked) {
        delete withoutMaskedData[fieldInfo.field]
      }
    }

    return withoutMaskedData
  }
}
